import React from 'react';
import Tooltip from 'rc-tooltip';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import EncounterDetailsModal from '../ProtocolSetup/EncounterDetailsModal/EncounterDetailsModal';

import 'components/pages/setup/Protocol/SourceDataPreview/EncounterComponent.scss';

const EncounterComponent = props => {
  return (
    <Tooltip
      placement="top"
      mouseEnterDelay={0}
      mouseLeaveDelay={0.1}
      destroyTooltipOnHide={false}
      trigger={Object.keys({ hover: 1 })}
      overlay={
        <div>
          {props.encDt && props.encDt.encounterName
            ? props.encDt.encounterName
            : props.encDt && props.encDt.displayName}
        </div>
      }
      align={{
        offset: [0, -3]
      }}
    >
      <div className="d-inline-block mr-4 mb-4 position-relative encounter-component-wrap">
        <span
          className="bg-light-grey px-2 py-1 rounded enprev"
          onClick={() => {
            ModalBoxes.open({
              component: (
                <EncounterDetailsModal enInfo={props.encDt} previousEpochEncounterList={[]} previewMode={true} />
              )
            });
          }}
        >
          {props.encDt && props.encDt.displayName}
        </span>
        <span
          title="Non protocol"
          className={`${
            props.encDt && props.encDt.nonProtocol ? 'bg-light-blue' : 'bg-dark'
          } shadows-enc data-preview `}
        />
      </div>
    </Tooltip>
  );
};

export default EncounterComponent;
